<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="new-survey">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm11 md8 elevation-6>
                <div class="sub-window">
                    <v-container pa-2 grid-list-md>
                        <v-card class="mx-auto" width="1000">
                            <v-img
                                class="teal--text text--lighten-3 align-end"
                                
                                src="@/assets/results1.jpg"
                                gradient="to bottom, rgba(0,0,0,0.8), rgba(0,0,0,0)"
                            >
                                <v-card-text class="headline">Inteligencia Ejecutiva - Resultados</v-card-text>
                                <v-card-text class="text-sm-left subtitle-2 pt-0 pb-0">
                                    {{ surveyUserName }}, {{ surveyUserGender }}, {{ surveyUserAge }} años
                                    <br>
                                    {{ surveyUserOrgLevel }}, {{ this.surveyResults.correoelectronico }} 
                                </v-card-text>
                                <v-divider class="teal lighten-3"></v-divider>

                            <v-card-text>
                               
                               <v-data-table
                                    readonly = "true"
                                    fixed-header
                                    :headers="resultsHeader"
                                    :items="resultsTableValues"
                                    locale="es-MX"
                                    hide-default-footer
                                    class="elevation-1"
                                    :show-select="false"
                                    single-select
                                    dense
                                    :items-per-page="14"
                                >
                                    <template #item="{ item }">
                                        <tr :class="item.bold === true ? 'bold-row' : 'normal-row'">
                                            <td style="text-align:left;">{{ item.concepto }}</td>
                                            <td>{{ item.positivos }}</td>
                                            <td>{{ item.ppositivos }}</td>
                                            <td>{{ item.negativos }}</td>
                                            <td>{{ item.pnegativos }}</td>
                                            <td>{{ item.total }}</td>
                                        </tr> 
                                        </template>
                                </v-data-table>
                            </v-card-text>
                            </v-img>
                        </v-card>

                        <v-layout align-center justify-end row fill-height>
                            <v-flex xs12 sm8 class="text-xs-center text-end">
                                <v-btn
                                    color="teal darken-3"
                                    class="text-none"
                                    text
                                    @click="onOK"
                                >OK</v-btn>
                            </v-flex>
                        </v-layout>
                           
                    </v-container>
                    
                </div>
            </v-flex>
            <!-- Fin Flex para la ventana **************************************************************** -->
        </v-layout>

        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'SurveyResults',
    data() {
        return {
            bDense: true,

            resultsHeader: [
                {
                    text: '',
                    sortable: false,
                    align: 'left',
                    value: 'concepto',
                },
                {
                    text: 'Puntos positivos',
                    sortable: false,
                    align: 'right',
                    value: 'positivos',
                },
                {
                    text: '% positivos',
                    sortable: false,
                    align: 'right',
                    value: 'ppositivos'
                },
                {
                    text: 'Puntos negativos',
                    sortable: false,
                    align: 'right',
                    value: 'negativos'
                },
                {
                    text: '% negativos',
                    sortable: false,
                    align: 'right',
                    value: 'pnegativos'
                },
                {
                    text: 'Total',
                    sortable: false,
                    align: 'right',
                    value: 'total'
                }
            ],

            resultsTableValues: [
                {
                    row: 1,
                    bold: false,
                    concepto: 'Inteligencia analítica y de detalle',
                    positivos: '0',
                    ppositivos: '0',
                    negativos: '0',
                    pnegativos: '0',
                    total: '0'
                },
                {
                    row: 2,
                    bold: false,
                    concepto: 'Claridad del costo-beneficio',
                    positivos: '0',
                    ppositivos: '0',
                    negativos: '0',
                    pnegativos: '0',
                    total: '0',
                },
                {
                    row: 3,
                    bold: false,
                    concepto: 'Pensamiento de largo plazo',
                    positivos: '0',
                    ppositivos: '0',
                    negativos: '0',
                    pnegativos: '0',
                    total: '0'
                },
                {
                    row: 4,
                    bold: false,
                    concepto: 'Inteligencia conceptual',
                    positivos: '0',
                    ppositivos: '0',
                    negativos: '0',
                    pnegativos: '0',
                    total: '0'
                },
                {
                    row: 5,
                    bold: true,
                    concepto: 'Promedio',
                    positivos: '0',
                    ppositivos: '0',
                    negativos: '0',
                    pnegativos: '0',
                    total: '0'
                },
                {
                    row: 6,
                    bold: false,
                    concepto: 'Inteligencia interpersonal',
                    positivos: '0',
                    ppositivos: '0',
                    negativos: '0',
                    pnegativos: '0',
                    total: '0'
                },
                {
                    row: 7,
                    bold: false,
                    concepto: 'Inteligencia conceptual',
                    positivos: '0',
                    ppositivos: '0',
                    negativos: '0',
                    pnegativos: '0',
                    total: '0'
                },
                {
                    row: 8,
                    bold: false,
                    concepto: 'Inteligencia social',
                    positivos: '0',
                    ppositivos: '0',
                    negativos: '0',
                    pnegativos: '0',
                    total: '0'
                },
                {
                    row: 9,
                    bold: true,
                    concepto: 'Promedio',
                    positivos: '0',
                    ppositivos: '0',
                    negativos: '0',
                    pnegativos: '0',
                    total: '0'
                },
                {
                    row: 10,
                    bold: false,
                    concepto: 'Auto-observación/Auto-conocimiento',
                    positivos: '0',
                    ppositivos: '0',
                    negativos: '0',
                    pnegativos: '0',
                    total: '0'
                },
                {
                    row: 11,
                    bold: false,
                    concepto: 'Capacidad de ajustar comportamiento',
                    positivos: '0',
                    ppositivos: '0',
                    negativos: '0',
                    pnegativos: '0',
                    total: '0'
                },
                {
                    row: 12,
                    bold: false,
                    concepto: 'Pensamiento ético',
                    positivos: '0',
                    ppositivos: '0',
                    negativos: '0',
                    pnegativos: '0',
                    total: '0'
                },
                {
                    row: 13,
                    bold: true,
                    concepto: 'Promedio',
                    positivos: '0',
                    ppositivos: '0',
                    negativos: '0',
                    pnegativos: '0',
                    total: '0'
                },
                {
                    row: 14,
                    bold: true,
                    concepto: 'Gran Promedio',
                    positivos: '0',
                    ppositivos: '0',
                    negativos: '0',
                    pnegativos: '0',
                    total: '0'
                }
            ]
        };
    },

    created()
    {
        var i;
        for (i = 0; i < this.surveyResults.conceptos.length; i ++)
        {
            this.resultsTableValues[i].positivos = this.surveyResults.conceptos[i].resultados[0];
            this.resultsTableValues[i].ppositivos = this.surveyResults.conceptos[i].resultados[1];
            this.resultsTableValues[i].negativos = this.surveyResults.conceptos[i].resultados[2];
            this.resultsTableValues[i].pnegativos = this.surveyResults.conceptos[i].resultados[3];
            this.resultsTableValues[i].total = this.surveyResults.conceptos[i].resultados[4];
        }
    },

    components: {},

    methods: {
        onOK() {
            this.$router.push('/').catch(err => {});
        },
    },
    computed: {
        ...mapGetters([
            'waitCursor',
            'ageRanges',
            'genders',
            'organizationalLevels',
            'surveyResults',
        ]),

        surveyUserName() {
            var strUserName = this.surveyResults.nombre + ' ' + this.surveyResults.apellidoPaterno;
            if (this.surveyResults.apellidoMaterno !== '')
            {
                strUserName += this.surveyResults.apellidoMaterno;
            }
            return strUserName;
        },

        surveyUserAge() {
            var strAge = "";
            var i;
            for (i = 0; i < this.ageRanges.length; i ++)
            {
                if (this.ageRanges[i].rangoedadid === this.surveyResults.edadid)
                {
                    strAge = this.ageRanges[i].rangoEdad;
                    break;
                }
            }
            return strAge;
        },

        surveyUserGender() {
            var strGender = "";
            var i;
            for (i = 0; i < this.genders.length; i ++)
            {
                if (this.genders[i].generoid === this.surveyResults.generoid)
                {
                    strGender = this.genders[i].genero;
                    break;
                }
            }
            return strGender;
        },

        surveyUserOrgLevel() {
            var strLevel = "";
            var i;
            for (i = 0; i < this.organizationalLevels.length; i ++)
            {
                if (this.organizationalLevels[i].nivelorganizacionalid === this.surveyResults.nivelorganizacionalid)
                {
                    strLevel = this.organizationalLevels[i].nivelOrganizacional;
                    break;
                }
            }
            return strLevel;
        },

        imgHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '800px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '600px';
            } else {
                height = '600px';
            }
            return height;
        },

        listHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '70px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '100px';
            } else {
                height = '120px';
            }
            return height;
        },

        modalWidth() {
            var width = '90%';
            if (this.$vuetify.breakpoint.xs) {
                width = '70%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '55%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '45%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '35%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '25%';
            }
            return width;
        },
        
        errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '70%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '50%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '30%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '20%';
            }
            return width;
        },
    },
};
</script>

<style scoped>
.sub-window {
    /* background-color: #e0e0e0; */
    /*grey lighten-2 */
    background: rgba(224, 224, 224, 0.9);
}
.new-survey {
    background: url('../assets/hunters-race-MYbhN8KaaEc-unsplash.jpg');
    background-size: cover;
    width: 100%;
    height: 100%;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}
.my-list-item {
    min-height: 30px !important;
}

.normal-row{
    font-weight: normal;
    color: black;
    background-color: white;
    text-align: right;
}

.bold-row{
    font-weight: bold;
    color: rgb(4, 104, 104);
    /* background-color: rgb(233, 233, 233); */
    background-color: rgb(228, 248, 248);
    text-align: right;
}


/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>